<template>
  <div>
    <InfoDetails :data="reportDetails">
      <template v-slot:time>
        <InfoTime :data="reportDetails" />
      </template>
      <FileEntry v-if="fileUrl" :url="fileUrl" class="file-entry--report" />
    </InfoDetails>
    <Disclaimer />
  </div>
</template>

<script>
import InfoDetails from '@/components/common/info/InfoDetails.vue'
import InfoTime from '@/components/common/info/InfoTime.vue'
import FileEntry from '@/components/common/info/FileEntry.vue'
import Disclaimer from '@/components/common/Disclaimer.vue'
export default {
  components: { InfoDetails, InfoTime, FileEntry, Disclaimer },
  computed: {
    fileUrl() {
      return this.$route.query.fileUrl
    },
    reportDetails() {
      const { title, source, time, content } = this.$route.query
      // UI需求，段前不空格，段间距为两倍行距
      return {
        title,
        source,
        time,
        content: content.replaceAll('　　', '').replaceAll('\n', '<div style="height: 20px"></div>')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.file-entry--report {
  margin-bottom: 15px;
}
</style>
